// extracted by mini-css-extract-plugin
export default {"key-id":"AMlMSxvkhM","keyId":"AMlMSxvkhM","right-tag":"GWAn0VC6oM","rightTag":"GWAn0VC6oM","none":"X2ZLFBFZuB"};